<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";
</script>

<div class="gw-wl-page-item-skeleton">
    <div class="gw-wl-page-item-skeleton__image">
        <ImageSkeleton ratio={1} />
    </div>
    <div class="gw-wl-page-item-skeleton__title">
        <BaseSkeleton width="90%" />
        <br />
        <BaseSkeleton width="80%" />
    </div>
</div>

<style lang="postcss">
    .gw-wl-page-item-skeleton__title {
        display: block;
        text-align: center;
        font-size: 1em;
        font-weight: 600;
        line-height: 1em;
        color: var(--gw-text-color);
        text-decoration: none;
        padding: 5px 0;
    }
</style>
